import { useState, useEffect } from "react";
import "./Navbar.css";

function Navbar({ currentPage, setCurrentPage }) {
  const [menuOpen, setMenuOpen] = useState(false);

  // Lock background scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <nav className="navbar">
      <div className="logo-container" onClick={() => handleNavClick("home")}>
        <img 
          src="/assets/logo.jpg" 
          alt="Vinayak Agro Chemicals Logo" 
          className="logo-image"
        />
      </div>
      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <button 
            className={`nav-btn ${currentPage === "home" ? "active" : ""}`}
            onClick={() => handleNavClick("home")}
          >
            Home
          </button>
        </li>
        <li>
          <button 
            className={`nav-btn ${currentPage === "about" ? "active" : ""}`}
            onClick={() => handleNavClick("about")}
          >
            About Us
          </button>
        </li>
        <li>
          <button 
            className={`nav-btn ${currentPage === "products" ? "active" : ""}`}
            onClick={() => handleNavClick("products")}
          >
            Products
          </button>
        </li>
        <li>
          <button 
            className={`nav-btn ${currentPage === "awards" ? "active" : ""}`}
            onClick={() => handleNavClick("awards")}
          >
            Hall of Fame
          </button>
        </li>
        <li>
          <button 
            className={`nav-btn ${currentPage === "contact" ? "active" : ""}`}
            onClick={() => handleNavClick("contact")}
          >
            Contact
          </button>
        </li>
      </ul>

      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
}

export default Navbar;

